angular.module('bb.users').config(UserRoutes);

UserRoutes.$inject = ['$routeProvider'];

function UserRoutes($routeProvider) {
  $routeProvider.when('/users/teams', {
    template: '<bb-team-list></bb-team-list>',
  });
}
export {};
